import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";

import { useModal } from "context/ModalContext";
import { Button } from "flowbite-react";

import "./styles.scss";

/**
 * Player do vídeo que explica como os cards são conquistados.
 *
 * A fonte é sempre um arquivo enviado em `upload_videos__c`, então o `<video>`
 * nativo basta — e é ele quem dita as proporções do modal, que aceita tanto o
 * vídeo vertical quanto o horizontal sem tarja preta.
 *
 * Espera em `modalData`: `{ title, url }`.
 */
export function VideoCardsModal() {
  const { user } = useAuth();
  const { openModal, modalData, closeModal } = useModal();

  const modalID = "modal-video-cards";

  const [modalIsOpen, setIsOpen] = useState(false);

  ReactModal.setAppElement("#modal");

  useEffect(() => {
    if (!user) return;
    setIsOpen(openModal === modalID);
  }, [user, openModal, modalData]);

  if (!user) return null;

  if (!modalData?.url) return null;

  const { title, url } = modalData;

  return (
    <ReactModal
      shouldCloseOnOverlayClick={false}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel={title}
      portalClassName="relative z-50"
      overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-gray-900 backdrop-blur-sm bg-opacity-90 flex flex-col items-center justify-center"
      contentElement={() => (
        <div id="modalVideoCards">
          <div className="conteudo">
            <Button className="btnClose" type="button" onClick={closeModal}>
              X
            </Button>

            <h3>{title}</h3>

            <video src={url} controls autoPlay playsInline />
          </div>
        </div>
      )}
    />
  );
}
